import { render } from "./duplicate-pay-warning.vue?vue&type=template&id=6e517247&scoped=true&ts=true"
import script from "./duplicate-pay-warning.vue?vue&type=script&lang=ts"
export * from "./duplicate-pay-warning.vue?vue&type=script&lang=ts"

import "./duplicate-pay-warning.vue?vue&type=style&index=0&id=6e517247&scoped=true&lang=stylus"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e517247"]])

export default __exports__